var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81827 14.0909H8.63645V19.5454H10.2728V14.0909H13.0001V19.5454H14.6365V14.0909H17.3637V19.5454H19.0001V14.0909H21.7274V19.5454H23.3637V14.0909H24.1819C24.5424 14.0909 24.8605 13.8549 24.965 13.5098C25.0694 13.1648 24.9357 12.7919 24.6357 12.5919L16.4539 7.13737C16.1791 6.95421 15.821 6.95421 15.5462 7.13737L7.3644 12.5919C7.0644 12.7919 6.93071 13.1648 7.03516 13.5098C7.13967 13.8549 7.45778 14.0909 7.81827 14.0909Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.182 21.1816H23.3638H21.7274H19.0001H17.3638H14.6365H13.0001H10.2729H8.63649H7.8183C7.36645 21.1816 7.00012 21.548 7.00012 21.9998V24.1816C7.00012 24.6335 7.36645 24.9998 7.8183 24.9998H24.182C24.6338 24.9998 25.0001 24.6335 25.0001 24.1816V21.9998C25.0001 21.548 24.6338 21.1816 24.182 21.1816Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwo);
export default __webpack_public_path__ + "static/media/features-two.45a61dcc.svg";
export { ForwardRef as ReactComponent };